export default __webpack_public_path__ + "40688b12121eba429b82ca6e69944800.png";